import Model from '@spa/apps/trustup-pro-base-js/models/BaseModel';

export default class BaseModel extends Model
{

    init(data)
    {    
        super.init(data);

        this.setTrustUpIORelationships(data);
    }

    setTrustUpIORelationships(data)
    {
        this.worksite = this.getWorksite(true);
        this.worksitePhase = this.getWorksitePhase(true);
        this.trustUpIOTask = this.getTrustUpIOTask(true);
    }

    hasWorksite(id = null)
    {
        return this.hasRelationship('trustup-pro-worksite', 'worksite', id);
    }

    getWorksite(fresh = false)
    {
        if ( ! fresh ) {
            return this.worksite || null;
        }

        this.worksite = this.getRelationshipModel(window.App.$store.state.models.worksites, 'trustup-pro-worksite', 'worksite');
        
        if ( this.worksite && window.App.$store.state.worksite && window.App.$store.state.worksite.uuid == this.worksite.uuid ) {
            this.worksite = window.App.$store.state.worksite;
        }
        
        return this.worksite;
    }

    hasWorksitePhase(id = null)
    {
        return this.hasRelationship('trustup-pro-worksite', 'worksite-phase', id);
    }

    getWorksitePhase(fresh = false)
    {
        if ( ! fresh || ! this.worksite ) {
            return this.worksitePhase || null;
        }

        let relationship = this.getRelationshipData('trustup-pro-worksite', 'worksite-phase');
        if ( relationship && this.worksite.phases ) {
            this.worksitePhase = this.worksite.phases.find(t => t.uuid == relationship.model_id);
        }

        return this.worksitePhase;
    }

    getTrustUpIOTask(fresh = false)
    {
        if ( ! fresh || ! this.worksite || ! this.worksitePhase ) {
            return this.trustUpIOTask || null;
        }

        let relationship = this.getRelationshipData('trustup-io-tasks', 'task');
        if ( relationship && this.worksitePhase.trustup_io.tasks.tasks ) {
            this.trustUpIOTask = this.worksitePhase.trustup_io.tasks.tasks.find(t => t.uuid == relationship.model_id);
        }

        return this.trustUpIOTask;
    }

    hasTrustUpIOTask(id = null)
    {
        return this.hasRelationship('trustup-io-tasks', 'task', id);
    }

}